import { toast } from "sonner";
import { isLimitError, formatApiError } from "./api";

/** Handles API errors; special-cases 402 plan-limit with a friendly upgrade toast. */
export function handleApiError(err, fallback = "Failed") {
  if (isLimitError(err)) {
    const d = err?.response?.data?.detail || {};
    toast.error(d.message || "Plan limit reached — upgrade to continue.", {
      description: `${d.used}/${d.limit} used on ${d.plan_id} plan`,
      action: {
        label: "Upgrade",
        onClick: () => { window.location.href = "/subscription"; },
      },
      duration: 6000,
    });
    return;
  }
  // Pass the whole axios error so formatApiError can surface network/CORS
  // failures with an actionable message instead of swallowing them as
  // "Something went wrong."
  // Also log to console so users can share the exact error when reporting bugs.
  if (err) {
    // eslint-disable-next-line no-console
    console.error("[handleApiError]", {
      status: err?.response?.status,
      url: err?.config?.url,
      data: err?.response?.data,
      message: err?.message,
    });
  }
  toast.error(formatApiError(err) || fallback);
}
